import { render } from "./PropEditor.vue?vue&type=template&id=4e55f11c&scoped=true"
import script from "./PropEditor.vue?vue&type=script&lang=js"
export * from "./PropEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e55f11c"]])

export default __exports__